import { gql } from '@apollo/client';

export const UPSERT_OUTCOME_INDICATOR = gql`
  mutation UpsertOutcomeIndicator($input: UpsertOutcomeIndicatorInput!) {
    upsertOutcomeIndicator(input: $input) {
      id
    }
  }
`;
